import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'banner', data),
  get: (id) => Ajax('get', `banner/${id}`),
  create: (data) => Ajax('post', 'banner', data),
  update: (id, data) => Ajax('put', `banner/${id}`, data),
  enable: (id) => Ajax('put', `banner/${id}/enable`),
  disable: (id) => Ajax('put', `banner/${id}/disabled`),
  delete: (id) => Ajax('delete', `banner/${id}`),
};
